import { TriggerEvent } from "floating-vue";

const isTouchScreen = navigator.maxTouchPoints > 0;
const defaultTooltipTriggers: TriggerEvent[] = isTouchScreen ? ["focus", "click"] : ["hover"];

/**
 * Show/hide delay for hover-opened menus, overriding floating-vue's `menu` theme default of
 * `{ show: 0, hide: 400 }`.
 *
 * The show delay is what keeps a pointer that merely passes over the trigger from opening the menu
 * at all; the shorter hide delay is only the grace period for crossing the gap between the trigger
 * and the popper, so it can be well under the default. Both are pointless on touch, where these
 * menus open on tap (see `defaultTooltipTriggers`) and a show delay just reads as a dead control.
 */
const defaultMenuDelay = isTouchScreen ? { show: 0, hide: 0 } : { show: 200, hide: 200 };

async function copyText(text: string) {
	return await navigator.clipboard.writeText(text);
}

export { isTouchScreen, defaultTooltipTriggers, defaultMenuDelay, copyText };
